<div id="image-thumbnails-container">
  <div
    class="image-thumbnail"
    *ngFor="let image of images"
    (click)="onImageClicked(image)"
  >
    <img [src]="image.thumb_url || image.original_url" (error)="$event.target.onerror = null; $event.target.src = image.original_url" />
  </div>
</div>
